// Landing Animations

$(document).ready(function(){
setTimeout(function() { 
       $('.HeroWithVideo__inner').addClass('loaded_section');
    }, 200);
setTimeout(function() { 
       $('.logo_1_js').addClass('loaded_section');
    }, 400);
setTimeout(function() { 
       $('.logo_2_js').addClass('loaded_section');
    }, 600);
setTimeout(function() { 
       $('.logo_3_js').addClass('loaded_section');
    }, 800);
setTimeout(function() { 
       $('.logo_4_js').addClass('loaded_section');
    }, 1000);
setTimeout(function() { 
       $('.logo_5_js').addClass('loaded_section');
    }, 1000);
setTimeout(function() { 
       $('.logo_6_js').addClass('loaded_section');
    }, 1000);
});


$( document ).ready(function() {

var controller_6 = new ScrollMagic.Controller();
var controller_7 = new ScrollMagic.Controller();
var controller_8 = new ScrollMagic.Controller();
var controller_9 = new ScrollMagic.Controller();
  
  //   Landing Animations
  
  // create a scene
new ScrollMagic.Scene({
  triggerElement: ".landing-image-gallery",
  triggerHook: 0.7
})
.setClassToggle('.landing-image-gallery', 'slide_in')
.addTo(controller_6); // assign the scene to the controller
  
   // create a scene
new ScrollMagic.Scene({
  triggerElement: ".whole_how_it_works_section",
  triggerHook: 0.7
})
.setClassToggle('.whole_how_it_works_section', 'loaded_section')
.addTo(controller_7); // assign the scene to the controller
  
    // create a scene
new ScrollMagic.Scene({
  triggerElement: ".Top_section",
  triggerHook: 0.7
})
.setClassToggle('.Top_section', 'loaded_section')
.addTo(controller_8); // assign the scene to the controller
  
    // create a scene
new ScrollMagic.Scene({
  triggerElement: ".Next_section",
  triggerHook: 0.7
})
.setClassToggle('.Next_section', 'loaded_section')
.addTo(controller_9); // assign the scene to the controller
  
  
    // create a scene
new ScrollMagic.Scene({
  triggerElement: ".feel-livia",
  triggerHook: 0.7
})
.setClassToggle('.feel-livia', 'loaded_section')
.addTo(controller_9); // assign the scene to the controller
  
  
  
    // create a scene
new ScrollMagic.Scene({
  triggerElement: ".Proven-container",
  triggerHook: 0.7
})
.setClassToggle('.Proven-container', 'triggered_image')
.addTo(controller_9); // assign the scene to the controller
  
  
});